// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[test]8.1-13306(6ce2392700)-C04/11/2026-21:07:50-B04/11/2026-21:17:02' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[test]8.1-13306(6ce2392700)-C04/11/2026-21:07:50-B04/11/2026-21:17:02",
  branch: "test",
  latestTag: "8.1",
  revCount: "13306",
  shortHash: "6ce2392700",
  longHash: "6ce239270096fd9b11db6b768ca69dabd0d327f8",
  dateCommit: "04/11/2026-21:07:50",
  dateBuild: "04/11/2026-21:17:02",
  buildType: "Ansible",
  } ;
